import { DestroyRef, Injectable, inject } from '@angular/core'
import { LogService } from './log.service'
import { FetchService } from './fetch.service'
import { ApiRequestService } from './api-request.service'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { HttpErrorResponse } from '@angular/common/http'
import { ClientService } from './client.service'
import { IGetFiltersResponse } from '../interfaces/filter.interface'
import { FilterService } from './filter.service'
import { GlobalDataService } from './global-data.service'


@Injectable({
  providedIn: 'root'
})
export class FilterApiService {

  private _destroyRef = inject(DestroyRef)
  private _logger = inject(LogService)
  private _fetchService = inject(FetchService)
  private _apiRequestService = inject(ApiRequestService)
  private _clientService = inject(ClientService)
  private _filterService = inject(FilterService)
  private _globalDataService = inject(GlobalDataService)

  loadFilterSettings(): Promise<void> {
    return new Promise((resolve, reject) => {
      const endpoint = this._apiRequestService.buildEndpoint('webshop/equipment/filters', {
        meter_uod: this._clientService.getMeterUod(),
        lang: this._globalDataService.selectedLanguage().code,
      })
      this._fetchService.postRequest<IGetFiltersResponse>(endpoint, {
        fields: [
          ['category', 'sub_category'],
          ['make', 'model'],
          ['branch_country', 'branch_state', 'branch_city'],
          ['meter_miles_precise'],
          ['meter_hours'],
          ['list_price'],
          ['year'],
        ],
      }).pipe(
        takeUntilDestroyed(this._destroyRef),
      ).subscribe(response => {
        if (response instanceof HttpErrorResponse) {
          this._logger.error('Unable to load filters.  ', response)
          return reject()
        }
        this._filterService.filterSettings = response.results[0]
        resolve()
      })
    })
  }
}
